import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import config from '../../constant/config'
import useWindowDimensions from '../hooks/useWindowDimensions'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const form = useRef()

  const { width } = useWindowDimensions()

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()
    const formData = new FormData(form.current)
    const from_name = formData.get('name')
    var templateParams = {
      to_name: 'Alabi Temitope',
      from_name,
      message: formData.get('message'),
      reply_to: formData.get('email'),
      subject: formData.get('subject'),
    }
    // from_name
    console.warn('form data', from_name)
    emailjs
      .send(
        'contact_service',
        'template_bsev2md',
        templateParams,
        config.EMAILJS_PUBLIC_TOKEN
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, please try again')
        }
      )
  }

  return (
    <>
      <div className={`container contact-page ${width < 768 ? 'my-20' : ''} `}>
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am interested in freelance opportunities - especially on ambitious
            or large projects. However, if you have any other requests or
            questions, don't hesitate to contact me using below form either.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required />
                </li>
                <li className="half">
                  {/* "email" */}
                  <input
                    placeholder="Email"
                    type="email"
                    name="reply_to"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Shina Alani Adebayo,
          <br />
          USA,
          <br />
          2544 W Winston Rd, Anaheim, CA 92801.
          <br />
          <p>
            <a
              href="tel:+17122505005"
              style={{
                textDecoration: 'none',
                color: 'white',
                fontSize: '16px',
              }}
            >
              +17122505005
            </a>
          </p>
          <p style={{ margin: '0px 0px' }}>
            <a
              href="mailto:code2adebayo@gmail.com"
              style={{
                textDecoration: 'none',
                color: 'white',
                fontSize: '16px',
              }}
            >
              code2adebayo@gmail.com
            </a>
          </p>
        </div>
        <div className="map-wrap">
          <MapContainer center={[54.58466, -5.94226]} zoom={19}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[33.81386, -117.97478]}>
              <Popup>Azeez lives here, come over for a cup of coffee :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
